<template>
  <widget
    :color="color"
    icon="fa fa-robot"
    title="Answered calls"
    :percent="percent"
    :value="value"
    :tooltip="tooltip"
    :loading="loading"
  />
</template>

<script>
import apiDashboard from '@/apis/dashboard'

import Widget from '@/components/widget/widget10'

export default {
  props: {
    clear: Number,
    refresh: Object,
    from: String,
    to: String,
    direction: String
  },
  components: {
    Widget
  },
  data() {
    return {
      color:
        this.direction === 'outbound'
          ? this.$getVoiceOutboundColor[0]
          : this.$getVoiceColor[0],
      percent: 0,
      value: 0,
      tooltip: '%Answer = 0',
      loading: false
    }
  },
  watch: {
    clear: {
      handler(val) {
        if (val) this.loading = true
      }
    },
    'refresh.count': {
      immediate: true,
      handler(val) {
        this.getVoiceAnsweredCall()
      }
    }
  },
  methods: {
    async getVoiceAnsweredCall() {
      this.loading = true

      try {
        const obj = {
          from: this.from,
          to: this.to
        }

        const answeredCall = await apiDashboard.getVoiceAnsweredCall(obj)
        this.value = answeredCall.total
        this.percent = answeredCall.percent

        if (answeredCall.all !== 0)
          this.tooltip = `%Answer = ${answeredCall.total} / ${answeredCall.all}`
        else this.tooltip = '%Answer = 0'
      } catch {
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
